// CommentsHistoryAccordion.tsx
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  List,
  ListItem,
  ListItemText,
  Grid,
  Box,
  Chip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FC } from "react";

interface CommentItem {
  date: string;
  feedback: string;
  cloud: boolean;
  physical: boolean;
}

interface Props {
  history: Record<string, any>;
}

const CommentsHistoryAccordion: FC<Props> = ({ history }) => {
  const comments: CommentItem[] = Object.entries(history)
    .map(([date, item]) => ({
      date,
      feedback: item.details?.feedback ?? "",
      cloud: !!item.details?.cloudVoucherComplete,
      physical: !!item.details?.fisicalVoucherComplete,
    }))
    .filter((c) => c.feedback || c.cloud || c.physical);

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="body2" fontWeight="bold">
          Historial de Comentarios
        </Typography>
      </AccordionSummary>

      <AccordionDetails>
        <List dense>
          {comments.map(({ date, feedback, cloud, physical }) => (
            <ListItem key={date} divider>
              <ListItemText
                sx={{ m: 0, p: 0 }}
                primary={
                  <Grid container justifyContent="space-between" alignItems="center">
                    <Grid item xs>
                      <Typography variant="body2" fontWeight="bold">
                        {date}
                      </Typography>
                    </Grid>
                  </Grid>
                }
                secondary={
                  <Box sx={{ mt: 0.5 }}>
                    <Typography variant="body2" color="text.secondary">
                      {feedback}
                    </Typography>
                    <Box sx={{ mt: 1, display: "flex", gap: 1 }}>
                      <Chip
                        label={`¿Se entregan vouchers completos?: ${physical ? "Sí" : "No"}`}
                        size="small"
                      />
                      <Chip
                        label={`¿Se sube vouchers completos?: ${cloud ? "Sí" : "No"}`}
                        size="small"
                      />
                    </Box>
                  </Box>
                }
              />
            </ListItem>
          ))}
        </List>
      </AccordionDetails>
    </Accordion>
);
}
export default CommentsHistoryAccordion;
